<template>
  <div class="gauge-card">
    <div class="content">
      <!-- GAUGE -->
      <div class="gauge-wrapper">
        <svg
          viewBox="0 0 200 120"
          class="gauge"
          preserveAspectRatio="xMidYMid meet"
        >
          <!-- red -->
          <path
            d="M20 100 A80 80 0 0 1 86 32"
            fill="none"
            stroke="#f06565"
            stroke-width="20"
          />
          <!-- yellow -->
          <path
            d="M86 32 A80 80 0 0 1 114 32"
            fill="none"
            stroke="#fcc419"
            stroke-width="20"
          />
          <!-- green -->
          <path
            d="M114 32 A80 80 0 0 1 180 100"
            fill="none"
            stroke="#20c997"
            stroke-width="20"
          />

          <!-- needle -->
          <line
            x1="100"
            y1="100"
            :x2="needleX"
            :y2="needleY"
            stroke="#000"
            stroke-width="3"
          />
          <circle cx="100" cy="100" r="5" fill="#000" />

          <!-- percent -->
          <text x="100" y="115" text-anchor="middle" class="percent">
            {{ percent }}%
          </text>
        </svg>
      </div>

      <!-- INFO -->
      <div class="info">
        <p class="label">Overall Rating</p>
        <div class="rating" :style="{ color: statusColor }">
          {{ emoji }} <span>{{ rating }}</span>
        </div>
        <p class="outof">Out Of 5</p>
        <p class="status" :style="{ color: statusColor }">
          {{ statusText }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percentValue: { type: Number, default: 73.4 },
    rating: { type: Number, default: 4.21 },
  },
  computed: {
    percent() {
      return this.percentValue.toFixed(2);
    },

    emoji() {
      if (this.rating >= 4.5) return "😄";
      if (this.rating >= 3.5) return "😊";
      if (this.rating >= 2.5) return "😐";
      if (this.rating >= 1.5) return "😟";
      return "😡";
    },

    statusText() {
      if (this.rating >= 4.5) return "Very Positive";
      if (this.rating >= 3.5) return "Positive";
      if (this.rating >= 2.5) return "Neutral";
      if (this.rating >= 1.5) return "Negative";
      return "Very Negative";
    },

    statusColor() {
      if (this.rating >= 4.5) return "#20c997";
      if (this.rating >= 3.5) return "#6ab04c";
      if (this.rating >= 2.5) return "#fcc419";
      if (this.rating >= 1.5) return "#f08c00";
      return "#f06565";
    },

    angle() {
      return -180 + (this.percentValue * 180) / 100;
    },
    needleX() {
      const r = 70;
      return 100 + r * Math.cos((this.angle * Math.PI) / 180);
    },
    needleY() {
      const r = 70;
      return 100 + r * Math.sin((this.angle * Math.PI) / 180);
    },
  },
};
</script>

<style scoped>
.gauge-card {
  width: 100%;
  overflow-x: auto; /* จอเล็กมาก → scroll แทนล้น */
}
/* flex container */
.content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: nowrap;
}

/* SVG wrapper */
.gauge-wrapper {
  flex: 1 1 0; /* ✅ ยืด-หดตามพื้นที่ */
  max-width: clamp(220px, 60%, 520px);
}

/* SVG responsive */
.gauge {
  width: 100%;
  height: auto;
  display: block;
}

/* percent text */
.percent {
  font-size: 14px;
  font-weight: 600;
}

/* info */
.info {
  flex: 0 0 auto;
  min-width: clamp(120px, 28vw, 180px);
  text-align: left;
}

.label {
  font-size: clamp(12px, 2.5vw, 14px);
}

.rating {
  font-size: clamp(16px, 4vw, 28px);
  font-weight: bold;
  color: #6ab04c;
}

.outof {
  font-size: clamp(11px, 2.5vw, 14px);
}

/* Positive */
.status {
  font-size: clamp(12px, 3vw, 14px);
}
</style>
